import { render, staticRenderFns } from "./dyzkz.vue?vue&type=template&id=5a120744&"
import script from "./dyzkz.vue?vue&type=script&lang=js&"
export * from "./dyzkz.vue?vue&type=script&lang=js&"
import style0 from "./dyzkz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports